import { useStores } from "@stores/hooks/useStores.ts";

export function useClipboard() {
  const { notification } = useStores();

  const copy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);

      notification.success("Copied to clipboard");
    } catch (error) {
      notification.error(
        error instanceof Error ? error.message : "Copy failed"
      );
    }
  };

  return { copy };
}
